module.exports = __webpack_public_path__ + "img/settings.6348c87c.svg";